import { render, staticRenderFns } from "./CinemaDetail.vue?vue&type=template&id=746ad217&"
import script from "./CinemaDetail.vue?vue&type=script&lang=js&"
export * from "./CinemaDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports